import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const land = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.LAND_REQUEST:
      draft[action.key] = true;
      return draft;
    case ACTIONS.LAND_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.selected = action.response;
      return draft;
    case ACTIONS.LAND_CODE_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.codeDetail = action.response;
      return draft;
    case ACTIONS.LAND_ERROR:
      draft.loading = false;
      draft.error = action.error;
      return draft;
    default:
      return draft;
  }
});

export default land;
